import Chatbotview from "../Chatbot/Chatbotview";

export default function(){




    return (<>
    
    <Chatbotview/>
    </>)
}